module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/node_modules/crossfilter2/index.js
// module id = 326
// module chunks = 0